import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  AbstractControl,
  FormControl,
} from '@angular/forms';
import { ICoding } from 'src/app/interfaces/ICoding';
import { MatDialog } from '@angular/material/dialog';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from 'ngx-intl-tel-input-gg';
import { SwalToastService } from 'src/app/services/swal.service';

@Component({
    selector: 'app-emergency-contacts',
    templateUrl: './emergency-contacts.component.html',
    styleUrls: ['./emergency-contacts.component.css'],
    standalone: false
})
export class EmergencyContactsComponent implements OnInit {
  @Input() formSubmitted?: boolean = false;
  @Input() countriesList: ICoding[] = [];
  @Input() closestRelativesList: ICoding[] = [];

  emergencyContactsForm: FormGroup;
  isCountryCyprus: boolean = true;

  // Define the Cyprus cities
  cyprusCities: string[] = [
    'Nicosia',
    'Limassol',
    'Larnaca',
    'Paphos',
    'Famagusta',
    'Kyrenia',
  ];

  selectedDoctors: any[] = [];
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.Cyprus, CountryISO.Greece];

  constructor(
    private readonly formBuilder: FormBuilder,
    private dialog: MatDialog,
    private readonly swalToastService: SwalToastService
  ) {
    this.emergencyContactsForm = this.formBuilder.group({
      contacts: this.formBuilder.array([]),
    });
  }

  ngOnInit() {
    this.addEmergencyContact();
  }

  get contacts(): FormArray {
    return this.emergencyContactsForm.get('contacts') as FormArray;
  }

  // Access a specific contact FormGroup
  getContactFormGroup(index: number): AbstractControl {
    return this.contacts.at(index);
  }

  addEmergencyContact() {


    if (this.contacts.length >= 5) {
      this.swalToastService.toastWarning(
        'Maximum of 5 emergency contacts allowed'
      );
      return;
    }

    const contactForm = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.maxLength(50)]],
      identifierType: [''],
      identifier: [''],
      identifierCountry: [''],
      phoneNumber: ['', [Validators.required, Validators.maxLength(15)]],
      occupation: ['', Validators.maxLength(100)],
      street: [undefined, Validators.maxLength(50)],
      streetNumber: [undefined, Validators.maxLength(30)],
      apartmentNumber: [undefined, Validators.maxLength(30)],
      town: [undefined, Validators.maxLength(50)],
      postcode: [undefined, Validators.maxLength(30)],
      district: [undefined, Validators.maxLength(50)],
      country: [55],
      closestRelativeId: [undefined],
      closestRelativeOther: [''], // Free text input for "Other"
      email: [undefined, [Validators.email, Validators.maxLength(50)]],
    });

    this.contacts.push(contactForm);
    this.updateValidators();
  }

  removeEmergencyContact(index: number) {
    this.contacts.removeAt(index);
    this.updateValidators();
  }

  updateValidators() {
    this.contacts.controls.forEach((contact, index) => {
      // if (index === 0) {
      //   contact.get('identifierType')?.setValidators(Validators.required);
      //   contact.get('identifier')?.setValidators(Validators.required);
      // } else {
      contact.get('identifierType')?.clearValidators();
      contact.get('identifier')?.clearValidators();
      // }
      contact.get('identifierType')?.updateValueAndValidity();
      contact.get('identifier')?.updateValueAndValidity();
    });
  }

  onIdentifierTypeChange(type: string, index: number) {
    const contact = this.contacts.at(index);
    if (type === 'arc' || type == null) {
      contact.get('identifierCountry')?.setValue('');
      contact.get('identifierCountry')?.clearValidators();
    } else {
      contact.get('identifierCountry')?.setValidators(Validators.required);
    }
    contact.get('identifierCountry')?.updateValueAndValidity();
  }

  // Method to handle place of birth change
  onCountryChange(placeId: number): void {
    this.isCountryCyprus = placeId === 55; // Cyprus id is 55
  }

  getPhoneNumberControl(i: number): FormControl<string | null> {
    return (
      (this.getContactFormGroup(i).get('phoneNumber') as FormControl<
        string | null
      >) || new FormControl<string | null>(null)
    );
  }

  enter(event: any) {
    event.preventDefault();

    const nextButton = document.getElementById(
      'emergency-next-btn'
    ) as HTMLButtonElement;
    if (nextButton) {
      nextButton.click();
    } else {
      console.warn('Button not found.');
    }
  }
}
